import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export default class HttpPromiseService {
  private http = inject(HttpClient);

  public get<T>(url: string, options?: { headers?: HttpHeaders; params?: HttpParams }): Promise<T> {
    return firstValueFrom(this.http.get<T>(url, options));
  }

  public post<T>(url: string, body: unknown, options?: { headers?: HttpHeaders; params?: HttpParams }): Promise<T> {
    return firstValueFrom(this.http.post<T>(url, body, options));
  }

  public patch<T>(url: string, body?: unknown, options?: { headers?: HttpHeaders; params?: HttpParams }): Promise<T> {
    return firstValueFrom(this.http.patch<T>(url, body, options));
  }

  public put<T>(url: string, body: unknown, options?: { headers?: HttpHeaders; params?: HttpParams }): Promise<T> {
    return firstValueFrom(this.http.put<T>(url, body, options));
  }

  public delete<T>(url: string, options?: { headers?: HttpHeaders; params?: HttpParams; body?: unknown }): Promise<T> {
    return firstValueFrom(this.http.delete<T>(url, options));
  }
}
